var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7024 46.8638C29.4643 48.772 28.9618 62.3429 44.7587 61.8565C51.9431 61.6354 57.3978 57.6074 60.0984 51.7892C61.7617 48.2054 60.7058 47.1742 65.1429 47.0517C67.5305 58.4895 44.9667 75.9642 28.6729 59.5054C26.6419 57.4537 23.1794 53.3412 22.8627 49.932C22.594 47.0401 23.159 47.7887 24.7024 46.8638ZM62.8582 36.7061C53.3828 39.6025 51.8762 31.536 55.9246 28.3147C60.5601 24.626 66.6019 29.3114 62.8582 36.7061ZM32.8741 36.7962C23.8373 39.3219 21.6518 31.805 25.8989 28.3867C30.4324 24.7377 37.032 29.2651 32.8741 36.7962ZM0.222399 48.8151C2.4201 71.5269 22.8418 90.6874 48.5854 88.1555C71.5064 85.9014 90.8132 65.5713 88.0823 39.5297C85.6972 16.7904 65.1358 -2.42313 39.4139 0.249069C16.6469 2.61467 -2.2775 22.979 0.222399 48.8151Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji4);
export default __webpack_public_path__ + "static/media/friendemoji4.4d6d21cfdec747ed93674c0d39c910ed.svg";
export { ForwardRef as ReactComponent };